/* eslint-disable react-hooks/exhaustive-deps */
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";

import InputAdornment from "@mui/material/InputAdornment";
// import Typography from "@mui/material/Typography";
import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { Loading, useRedirect } from "react-admin";
import {
  BiChevronRight,
  BiPlusCircle,
  BiSearch,
  BiTrash,
  BiUserCircle,
  BiX,
} from "react-icons/bi";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { routePaths } from "../../baseLayout/SidebarMenu";
import { GenericList } from "../../components";
import { dataType } from "../../components/GenericList/GenericList";
import NotificationMessage, {
  notificationType,
} from "../../components/NotificationMessage/NotificationMessage";
import FdButton from "../../components/UIComponents/Button/FdButton";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import IUser from "../../dataProvider/interfaces/IUser";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";
import { APIContext } from "../../store/APIStore";
import { StoreContext } from "../../store/Store";
import { theme } from "../../theme";
import UserForm from "./UserForm/UserForm";
import {usersOverview as classes} from "./styles";



const UsersOverview = () => {
  const [state] = useContext(StoreContext);
  const [userCount, setUserCount] = useState<Number>(0);
  const [userList, setUserList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [selectedUser, setSelectedUser] = useState<IUser | null>();
  const notificationRef = useRef<any>();
  const api = useContext(APIContext);
  const redirect = useRedirect();
  const location = useLocation().search;
  let navigate = useNavigate();

  // permissions
  const canManageUser = useHasPermissions(PERMISSIONS.CAN_MANAGE_USER);

  // redirect if no permission to access this page
  useEffect(() => {
    if (canManageUser === false) {
      redirect(`/${routePaths.ACTIVE_EVENTS}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canManageUser]);

  useEffect(() => {
    const search = new URLSearchParams(location).get("search");

    if (search) {
      setSearchKey(search);
      fetchUsers(search);
    } else {
      fetchUsers("");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      userList?.length > 0 &&
      state?.currentUser?.id &&
      selectedUser === undefined
    ) {
      setSelectedUser(
        userList.filter((user: IUser) => user.id === state.currentUser.id)[0]
      );
    }
  }, [userList, state?.currentUser?.id, selectedUser]);

  const fetchUsers = async (keyword: string, start?: number) => {
    if (!start) {
      setLoading(true);
    }

    try {
      const { data, count } = await api.userService.getUsers(keyword, start);
      setUserCount(count);
      if (start) {
        setUserList([...userList, ...data]);
      } else {
        setUserList(data);
      }

      setLoading(false);
    } catch (error: any) {
      console.error(error);
      notificationRef?.current?.show(
        error?.response?.data?.message,
        notificationType.Error
      );
    }
  };

  const onSearchClick = (e: any) => {
    redirect(`/${routePaths.USERS}?search=${searchKey}`);
    fetchUsers(searchKey);
  };

  const handleListPagination = () => {
    if (userList.length < userCount) {
      fetchUsers(searchKey, userList.length);
    }
  };

  const handleSearchClear = () => {
    redirect(`/${routePaths.USERS}`);
    setSearchKey("");
    fetchUsers("");
  };

  const handleSearchKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      redirect(`/${routePaths.USERS}?search=${searchKey}`);
      fetchUsers(searchKey);
    }
  };

  // const handleDeleteUsers = async (userIds: any[]) => {
  //   try {
  //     setLoading(true);
  //     await Promise.all(
  //       userIds.map((id) => {
  //         return api.userService.delete(id);
  //       })
  //     );
  //     handleSearchClear();
  //   } catch (error: any) {
  //     console.log(error.response);
  //     notificationRef.current?.show(
  //       error.response.data.message,
  //       notificationType.Error
  //     );
  //   }
  // };

  const handleUserSave = (newUser: IUser) => {
    if (
      newUser.id === state?.currentUser?.id &&
      newUser.account.id !== state?.currentUser?.account?.id
    ) {
      navigate(0);
    } else if (userList.every((user: IUser) => user.id !== newUser.id)) {
      fetchUsers("");
    } else {
      const newUserList = userList.map((user: IUser) => {
        if (user.id === newUser.id) {
          return { ...user, ...newUser };
        } else {
          return user;
        }
      });
      setUserList(newUserList);
    }
    setSelectedUser(newUser);

    if (notificationRef && notificationRef.current) {
      notificationRef.current?.show(
        "User successfully saved",
        notificationType.Success
      );
    }
  };

  const handleBulkDelete = async (items: number[]) => {
    try {
      await Promise.all(
        items.map((item) => {
          return api.userService.delete(item);
        })
      );
      fetchUsers("");
      notificationRef.current?.show(
        "Users successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleDeleteUser = async (id: number) => {
    try {
      await api.userService.delete(id);
      fetchUsers("");
      notificationRef.current?.show(
        "User successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  // actions applied on selected items
  const bulkActions = [
    {
      label: "Delete",
      key: "delete",
      callback: handleBulkDelete,
      startIcon: <BiTrash />,
    },
  ];

  return (
    <>
      <Box sx={classes.wrapper}>
        <Box sx={classes.topActions}>
          <FdTypography label=" Users" component="h3" variant="h3" />
          <Box flexGrow="1" textAlign="right" paddingRight="20px">
            
            <FdTypography variant="body1" lineHeight={1} label={<>
              <BiUserCircle
              style={{
                position: "relative",
                top: "3px",
                marginRight: "7px",
                color: theme.palette.text.primary,
                fontSize: "18px",
              }}
            />Total number of users:{" "}
              <Box component="span" style={{ lineHeight: 1 }} fontWeight="bold">
                {`${userCount}`}
              </Box>{" "}</>} />
          </Box>
          {canManageUser && (
            <FdButton
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<BiPlusCircle />}
              onClick={(event) => {
                setSelectedUser(null);
              }}
              ButtonName="Add new user"
            />
          )}
        </Box>
        <Box sx={classes.topFilters} display="flex">
          {/* <Paper sx={classes.searchForm}> */}
            <FdTextField
              sx={classes.searchInput}
              placeholder="Search"
              value={searchKey}
              onChange={(e) => {
                const keyword = e.target.value;
                setSearchKey(keyword);
                // if (keyword.length === 0) {
                //   fetchUsers("");
                // }
              }}
              autoFocus
              onKeyDown={handleSearchKeyDown}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BiSearch size="18" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={classes.clearIcon}
                    onClick={handleSearchClear}
                  >
                    {searchKey.length > 0 && <BiX size="20" />}
                  </InputAdornment>
                ),
              }}
            />
          {/* </Paper> */}
          <FdButton
                variant="contained"
                color="primary"
                onClick={onSearchClick}
                sx={classes.searchButton}
                ButtonName="Search"
              />
        </Box>
        {!loading && (
          <Box sx={classes.listContent}>
            <GenericList
              items={userList}
              onSelectItem={(item: IUser) => {
                setSelectedUser(item);
              }}
              type={dataType.USERS}
              onBottomScroll={handleListPagination}
              onDeleteItem={canManageUser ? handleDeleteUser : undefined}
              selectedItem={selectedUser}
              bulkActions={canManageUser ? bulkActions : undefined}
            />
            <BiChevronRight size="50" color={theme.palette.grey["800"]} />
            <UserForm
              user={selectedUser}
              onUserSave={handleUserSave}
              onError={(error: string) => {
                notificationRef.current?.show(error, notificationType.Error);
              }}
            />
          </Box>
        )}
        {loading && <Loading />}
      </Box>

      <NotificationMessage ref={notificationRef} />
    </>
  );
};

export default UsersOverview;
